
import { debounce } from "debounce";
export default {
  name: "filters",
  props: ["open"],
  data() {
    return {
      sort: "asc",
      selected: [],
      expand: {},
      fastFilters: {},
      bounce: false,
      loading: false,
      keys: {
        business_activity: "Δραστηριότητες",
        family: "Οικογένειες",
        subfamily: "Υποοικογένειες",
        category: "Κατηγορίες",
        manufacturer: this.$store.getters.labels.manufacturer,
        "tags.cover": "Εξώφυλλο",
        "tags.series": "Σειρά",
        "tags.pages": "Σελίδες",
        "tags.author": "Συγγραφέας",
        "tags.persons": "Συγγραφέας",
        "tags.release_date": "Ημερομηνία κυκλοφορίας",
      },
    };
  },
  watch: {
    sort: function (v) {
      this.$emit("updateSort", v);
    },
    "$store.getters.sideFilters": {
      handler(v) {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  mounted() {
    if(this.$store.getters.store.eshop && this.$store.getters.store.eshop.filter_labels){
      for(let k in this.$store.getters.store.eshop.filter_labels){
        if(this.$store.getters.store.eshop.filter_labels[k]){
          this.keys[k] = this.$store.getters.store.eshop.filter_labels[k];
        }
      }
    }
  },
  methods: {
    async clearQ() {
      let temp = this.$store.getters.sideFilters;
      delete temp.q;
      this.$store.commit("sideFilters", { ...temp });
      await this.$store.dispatch("doSearch");
      await this.$store.dispatch("getAutoCompletes", {
        merge: true,
        properties: "manufacturer,tags",
      });
    },
    resetFilters() {
      this.$emit("closePanel");
      this.$emit("resetFilters");
    },
    closePanel() {
      this.$emit("closePanel");
    },
    doFilters() {
      this.$emit("closePanel");
      this.$emit("updateSort");
    },
    async externalSearch(v, sfilter) {
      //from api
      if (
        !this.$store.getters.sidePanel[sfilter].all.filter((a) =>
          a.toLowerCase().includes(v.toLowerCase())
        ).length
      ) {
        if (v.length < 3) {
          return;
        }
        var self = this;
        if (this.bounce) {
          return;
        }
        var deb = debounce(async () => {
          this.loading = true;
          this.dirty = true;
          let temp = await this.$axios.$get(
            `/items/distinct/${sfilter}?store_id=${
              this.$store.getters.store._id
            }&query=${encodeURIComponent(v)}`
          );
          if (temp) {
            let sp = JSON.parse(JSON.stringify(this.$store.getters.sidePanel));
            sp[sfilter].all = [...temp, ...sp[sfilter].all];
            self.$store.commit("sidePanel", sp);
          }
          self.loading = false;
          self.bounce = false;
        }, 500);
        deb();
        this.bounce = true;
      }
    },
    async selectFilter(ba, sfilter) {
      this.$emit("closePanel");
      await this.$store.dispatch("syncSearch", { ba, sfilter });
      await this.$store.dispatch("doSearch");
      await this.$store.dispatch("getAutoCompletes", {
        merge: true,
        properties: "manufacturer,tags",
      });
      window.scrollTo(0, 0);
    },
  },
};
